// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_MyFranchisesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_MyFranchisesResponse — list of the caller's franchises with
 * their subscription status (including terminal rows — cancelled/superseded).
 *
 * Used by GET /subscriptions/my-franchises (R2a).
 */
import type { Subscriptions_MyFranchiseRow } from './Subscriptions_MyFranchiseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_MyFranchisesResponseDados {
rows: Subscriptions_MyFranchiseRow[]
}

export type Subscriptions_MyFranchisesResponse = ApiResponse<Subscriptions_MyFranchisesResponseDados>;

registerResponseContract('Subscriptions_MyFranchisesResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      franchise_id:    { type: 'number',  required: true },
      subscription_id: { type: 'number',  required: false },
      status:          { type: 'string',  required: false },
      exempt:          { type: 'number',  required: false },
      plan_name:       { type: 'string',  required: false },
      franchise_name:  { type: 'string',  required: false },
      grace_until:     { type: 'string',  required: false },
      days_remaining:  { type: 'number',  required: false },
      data_allowed:    { type: 'boolean', required: false },
      setup_status:    { type: 'string',  required: false },
    },
  },
})
